/**
 * @param {{ respuestasMezcladas?: Array<{ texto?: string; esCorrecta?: boolean }> }} pregunta
 * @returns {string}
 */
export function getCorrectAnswerText(pregunta) {
  if (!pregunta || typeof pregunta !== "object") {
    return "";
  }
  if (!Array.isArray(pregunta.respuestasMezcladas)) {
    return "";
  }
  const hit = pregunta.respuestasMezcladas.find((r) => r.esCorrecta === true);
  const texto = hit?.texto;
  return typeof texto === "string" && texto.trim() !== "" ? texto.trim() : "";
}

/**
 * @param {Array<{ pregunta?: string; respuestasMezcladas?: Array<{ texto?: string; esCorrecta?: boolean }> }>} preguntasTest
 * @param {Record<number, number>} respuestasUsuario
 * @returns {Array<{ pregunta: string; respuesta: string; esCorrecta: boolean; respuestaCorrecta: string }>}
 */
export function buildTestAttemptDetalle(preguntasTest, respuestasUsuario) {
  if (!Array.isArray(preguntasTest)) {
    return [];
  }
  const answers =
    respuestasUsuario && typeof respuestasUsuario === "object" ? respuestasUsuario : {};
  return preguntasTest.map((rawP, idx) => {
    const p = rawP && typeof rawP === "object" ? rawP : {};
    const respIdx = answers[idx];
    const respuestasMezcladas = Array.isArray(p.respuestasMezcladas) ? p.respuestasMezcladas : [];
    let respuesta = "(sin respuesta)";
    let esCorrecta = false;
    if (respIdx !== undefined && respuestasMezcladas[respIdx]) {
      const chosen = respuestasMezcladas[respIdx];
      if (chosen && typeof chosen === "object") {
        const texto = chosen.texto;
        respuesta = typeof texto === "string" && texto.trim() !== "" ? texto : "(sin respuesta)";
        esCorrecta = chosen.esCorrecta === true;
      }
    }
    const pregunta = typeof p.pregunta === "string" ? p.pregunta : "";
    return {
      pregunta,
      respuesta,
      esCorrecta,
      respuestaCorrecta: getCorrectAnswerText(p),
    };
  });
}
